import { Box } from "@mui/material";
import { Card, Typography, palette } from "@powerdiary/components-library/lib";
import styles from "./SummaryItem.module.css";

interface SummaryItemProps {
    title: string;
    content: string;
    onClick: () => void;
    dataTestIdSuffix: string;
}

export default function SummaryItem({ title, content, onClick, dataTestIdSuffix }: Readonly<SummaryItemProps>) {
    return (
        <Card
            onClick={onClick}
            className={styles.wrapper}
            sx={{ backgroundColor: palette.neutral["50"], padding: "8px" }}
            data-test-id={`card_summary_item_${dataTestIdSuffix}`}
        >
            <Box>
                <Typography variant="paragraphSmallRegular">{title}</Typography>
            </Box>

            <Box sx={{ overflowWrap: "break-word" }}>
                <Typography variant="paragraphMediumSemiBold" color="primary">
                    {content}
                </Typography>
            </Box>
        </Card>
    );
}
